export type DashboardScope = 'meine' | 'alle';

export interface ScopeNutzer { id: string; team_ids?: string[] }

// Rollen mit Gesamtsicht. Alles andere (Rolle 'team') sieht auf dem Dashboard ausschließlich
// die eigenen bzw. Team-Vorgänge — ohne Umschalter und ohne firmenweite Blöcke.
const ADMIN_ROLLEN = ['admin', 'super admin', 'master admin'];

/**
 * Bekommt dieser Nutzer nur seine eigene Sicht? Unbekannte/noch nicht geladene Rolle zählt
 * bewusst als „nur eigene": lieber kurz zu wenig zeigen als einer Mitarbeiterin für einen
 * Wimpernschlag die Firmenzahlen.
 */
export function nurEigeneSicht(userProfile: { role?: string | null } | null | undefined): boolean {
  return !ADMIN_ROLLEN.includes((userProfile?.role || '').toLowerCase());
}

export interface ScopeBeleg {
  zustaendig_id?: string | null;
  zustaendig_typ?: string | null;
  tech_pruefung_an?: string | null;
  freigabe_angefordert_an?: string | null;
}

/**
 * Ist dieser Beleg meine Aufgabe? Zuständigkeit (ich oder mein Team) — oder er liegt mir zur
 * technischen Prüfung / Freigabe vor. Dieselbe Regel wie im Arbeitsvorschlag, damit Kennzahl
 * und Aufgabenliste nicht auseinanderlaufen.
 */
export function istMeinBeleg(beleg: ScopeBeleg, nutzer: ScopeNutzer): boolean {
  if (istMeineZustaendigkeit(beleg.zustaendig_id, beleg.zustaendig_typ, nutzer)) return true;
  if (!nutzer.id) return false;
  return beleg.tech_pruefung_an === nutzer.id || beleg.freigabe_angefordert_an === nutzer.id;
}

/** Gehört eine Zuständigkeit (Mitarbeiter ODER Team) zum Nutzer? */
export function istMeineZustaendigkeit(
  zustaendigId: string | null | undefined,
  zustaendigTyp: string | null | undefined,
  nutzer: ScopeNutzer,
): boolean {
  if (!zustaendigId) return false;
  if (zustaendigTyp === 'team') return (nutzer.team_ids || []).includes(zustaendigId);
  return zustaendigId === nutzer.id;
}
